import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useProvider'
import useCurrentUser from '@hooks/useCurrentUser'

import EntitySelector from '@components/EntitySelector'

const Details = (props) => {
  const { providerPackageForm } = props

  const { isProviderDirector } = useCurrentUser()

  const {
    entityState: {
      price,
      product_code,
      provider_id,
      title,
    },
    errors,
    handlers,
    setEntityState,
  } = providerPackageForm

  const { editProviderUrl } = generateUrls({ id: provider_id })

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <EntitySelector
            boxProps={{ marginTop: ['large', 0] }}
            callbacks={{
              selectItem: provider => setEntityState({ provider_id: provider ? provider.id : null }),
            }}
            disabled={isProviderDirector}
            entityKey="providers"
            errorMessage={errors.provider_id}
            goToHref={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
            label="* Provider"
            selectedItemId={provider_id}
          />
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.price} label="* Price">
            <input name="price" type="number" value={price} {...handlers} />
          </Form.Field>

          <Form.Field label="Product Code" marginTop={['large', 0]}>
            <input name="product_code" type="text" value={product_code} {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

Details.propTypes = {
  providerPackageForm: PropTypes.object.isRequired,
}

export default Details
